import { ContactFilters__Input } from '~/graphql/types';

const deserializeFiltersV2 = (filters: string): ContactFilters__Input =>
  JSON.parse(atob(decodeURIComponent(filters)));

export default deserializeFiltersV2;
